import { getApiBaseUrl } from '../utils/apiConfig';

const API_BASE_URL = getApiBaseUrl();

// Standard headers for API calls
const getHeaders = (additionalHeaders = {}) => ({
  'Content-Type': 'application/json',
  ...additionalHeaders
});

// Validate Pabau API key and get clinic information
export const validatePabauApiKey = async (apiKey, baseUrl = 'https://api.pabau.com') => {
  const formData = new FormData();
  formData.append('api_key', apiKey);
  formData.append('base_url', baseUrl);

  const response = await fetch(`${API_BASE_URL}/onboarding/validate-api-key`, {
    method: 'POST',
    body: formData
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.detail || 'API key validation failed');
  }

  return response.json();
};

// Validate step data
export const validateStep = async (stepNumber, stepData) => {
  const response = await fetch(`${API_BASE_URL}/onboarding/validate-step`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({
      step: stepNumber,
      data: stepData
    })
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.detail || 'Step validation failed');
  }

  return response.json();
};

// Start trial onboarding
export const startTrialOnboarding = async (onboardingData) => {
  const response = await fetch(`${API_BASE_URL}/onboarding/start-trial`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(onboardingData)
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.detail || 'Trial onboarding failed');
  }

  return response.json();
};

// Get onboarding progress
export const getOnboardingProgress = async (sessionId) => {
  const response = await fetch(`${API_BASE_URL}/onboarding/${sessionId}/progress`, {
    method: 'GET',
    headers: getHeaders()
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.detail || 'Failed to get onboarding progress');
  }

  return response.json();
};

// Preview import data
export const previewImportData = async (apiKey, importConfig) => {
  const response = await fetch(`${API_BASE_URL}/onboarding/preview-data`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({
      api_key: apiKey,
      import_config: importConfig
    })
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.detail || 'Failed to preview import data');
  }

  return response.json();
};

// Create payment intent for embedded payment
export const createPaymentIntent = async (leadId) => {
  const response = await fetch(`${API_BASE_URL}/onboarding/create-payment-intent/${leadId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    }
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.detail || 'Failed to create payment intent');
  }

  return response.json();
};

// Confirm payment for embedded payment
export const confirmPayment = async (leadId, paymentData) => {
  const response = await fetch(`${API_BASE_URL}/onboarding/confirm-payment/${leadId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(paymentData)
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.detail || 'Failed to confirm payment');
  }

  return response.json();
};

// Setup Pabau automation
export const setupPabauAutomation = async (credentials, leadId) => {
  const response = await fetch(`${API_BASE_URL}/onboarding/setup-pabau`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({
      username: credentials.username,
      password: credentials.password,
      leadId: leadId
    })
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.detail || 'Pabau automation setup failed');
  }

  return response.json();
}; 